var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-container",style:(_vm.styles)},[_c('canvas',{ref:"chart",attrs:{"width":"100%","height":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }